import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getAllMonsterSaleUserSuccess,
  getAllMonsterSaleUserFailed,
  GET_ALL_MONSTER_SALE_USER_START,
} from '../../actions/monster'

/**
 * get list monster sale user
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListMonsterSaleUserApi = (props) => {
  var uri = `/monsters`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListMonsterSaleUser(action) {
  try {
    const response = yield call(getListMonsterSaleUserApi, action?.payload)
    yield put(getAllMonsterSaleUserSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getAllMonsterSaleUserFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list monster sale user
 */
export default function* watchGetListMonsterSaleUser() {
  yield takeLatest(GET_ALL_MONSTER_SALE_USER_START, doGetListMonsterSaleUser)
}
